import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PublicLayout } from "@/components/Layout";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export function BlogList() {
  const [items, setItems] = useState([]);
  useEffect(()=>{ api.get("/contents").then(r=>setItems(r.data)); }, []);
  return (
    <PublicLayout>
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="text-xs uppercase tracking-widest text-[#0D7C66] font-semibold">Conteúdo</div>
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-8" style={{fontFamily:"Plus Jakarta Sans"}}>Blog GIRO+SAÚDE</h1>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map(c=>(
            <Link key={c.slug} to={`/blog/${c.slug}`} data-testid={`blog-${c.slug}`} className="group rounded-2xl overflow-hidden bg-white border border-slate-200 gs-shadow hover:-translate-y-0.5 transition">
              {c.image_url && <img src={c.image_url} alt={c.title} className="h-44 w-full object-cover"/>}
              <div className="p-5">
                <Badge className="bg-[#E6F4F1] text-[#0D7C66] border-0 mb-2">{c.category}</Badge>
                <div className="font-semibold text-lg leading-snug">{c.title}</div>
                <div className="text-sm text-slate-500 mt-1">{c.subtitle}</div>
                <div className="text-xs text-slate-400 mt-3">Por {c.author}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  useEffect(()=>{ api.get(`/contents/${slug}`).then(r=>setC(r.data)).catch(()=>{}); }, [slug]);
  if (!c) return <PublicLayout><div className="max-w-3xl mx-auto p-10">Carregando…</div></PublicLayout>;
  return (
    <PublicLayout>
      <article className="max-w-3xl mx-auto px-6 py-12">
        <Badge className="bg-[#E6F4F1] text-[#0D7C66] border-0 mb-3">{c.category}</Badge>
        <h1 className="text-3xl sm:text-4xl font-extrabold" style={{fontFamily:"Plus Jakarta Sans"}}>{c.title}</h1>
        <div className="text-slate-500 mt-2">{c.subtitle}</div>
        {c.image_url && <img src={c.image_url} alt={c.title} className="w-full rounded-2xl mt-6"/>}
        <div className="mt-6 text-slate-700 leading-relaxed whitespace-pre-line">{c.body}</div>
        <div className="mt-8 text-sm text-slate-500">Por {c.author}</div>
      </article>
    </PublicLayout>
  );
}
